export enum SexEnum {
  male = 'male',
  female = 'female',
}

export type Sex = SexEnum.male | SexEnum.female;
